// @flow
import i18next from 'i18next'

type Opts = {
  min: number,
  max: number,
}

type Response = {
  isValid: boolean,
  message: string,
}

type HydrateFunction = (value: any) => any

export default ({ min = 0, max = Infinity }: Opts, hydrate: HydrateFunction = value => value) =>
  (value: any): ?Response => {
    const hydratedValue = hydrate(value)
    if (!Array.isArray(hydratedValue)) {
      return {
        isValid: false,
        message: i18next.t(`select at least min item`, { min }),
      }
    }
    if (hydratedValue.length < min) {
      return {
        isValid: false,
        message: i18next.t(`select at least min item`, { min }),
      }
    } else if (hydratedValue.length > max) {
      return {
        isValid: false,
        message: i18next.t(`select not more then max item`, { max }),
      }
    }
  }
